export function goDetail(type: Exclude<Api.Dim.Type, 'product'> | 'products', id: string, tab?: string) {
  if (!id)
    return
  const { baseURL } = useRuntimeConfig().app
  const localePath = useLocalePath()
  navigateTo(`${baseURL === '/' ? '' : baseURL}${localePath(`/analysis/${type}/detail/${id}${tab ? `?type=${tab}` : ''}`)}`, { open: { target: '_blank' } })
}
export const needLoginPath = ['/user/info', '/user/member', '/user/order'] // Add paths that require login
export function localizedNeedLoginPath() {
  const localePath = useLocalePath()
  return needLoginPath.map(path => localePath(path))
}

/**
 * 字符超出 maxLength 个字符，则截取并添加省略号
 */
export function stringOverflow(str: string, maxLength: number) {
  if (str.length > maxLength) {
    return `${str.slice(0, maxLength)}...`
  }
  return str
}

/**
 * 针对显示总销量的地方，需要展示原销量和总销量，取最大值
 */
export function getMaxSoldCount(data: { originalSoldCount?: string, soldCount?: string }): string {
  const { originalSoldCount, soldCount } = data || {}
  if (originalSoldCount && soldCount)
    return String(Math.max(Number(originalSoldCount), Number(soldCount)))
  return String(originalSoldCount || soldCount || '')
}
export function validateEmail(email: string) {
  const emailRegex = /^[\w.-]+@[a-z0-9.-]+\.[a-z]{2,6}$/i
  return emailRegex.test(email)
}
